import { Resource } from 'constants/resources';

import { MenuItem, MenuList, MultiLevelMenuItem } from 'layouts/components/Menu/constants/menuList';

const isMultiLevelMenuItem = (item: MenuItem | MultiLevelMenuItem): item is MultiLevelMenuItem => {
  return 'items' in item;
};

export const filterMenuList = (list: MenuList, isVisible: (resource: Resource) => boolean) => {
  return list.flatMap((section): MenuList => {
    if (!isMultiLevelMenuItem(section)) {
      return isVisible(section.resource) ? [section] : [];
    }

    const items = section.items.filter((item) => isVisible(item.resource));
    return items.length ? [{ ...section, items }] : [];
  });
};
